<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft">AB</td>
<td class="tdleft">Anchor Bible</td>
</tr>
<tr>
<td class="tdleft"><i>AJA</i></td>
<td class="tdleft"><i>American Journal of Archaeology</i></td>
</tr>
<tr>
<td class="tdleft">BECNT</td>
<td class="tdleft">Baker Exegetical Commentary on the New Testament</td>
</tr>
<tr>
<td class="tdleft">BGBE</td>
<td class="tdleft">Beiträge zur Geschichte der biblischen Exegese</td>
</tr>
<tr>
<td class="tdleft"><i>BLE</i></td>
<td class="tdleft"><i>Bulletin de littérature ecclésiastique</i></td>
</tr>
<tr>
<td class="tdleft"><i>BSac</i></td>
<td class="tdleft"><i>Bibliotheca Sacra</i></td>
</tr>
<tr>
<td class="tdleft"><i>CBQ</i></td>
<td class="tdleft"><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td class="tdleft"><i>CH</i></td>
<td class="tdleft"><i>Church History</i></td>
</tr>
<tr>
<td class="tdleft"><i>CJ</i></td>
<td class="tdleft"><i>Concordia Journal</i></td>
</tr>
<tr>
<td class="tdleft"><i>ExAud</i></td>
<td class="tdleft"><i>Ex Auditu</i></td>
</tr>
<tr>
<td class="tdleft">HNT</td>
<td class="tdleft">Handbuch zum Neuen Testament</td>
</tr>
<tr>
<td class="tdleft"><i>HTR</i></td>
<td class="tdleft"><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td class="tdleft">ICC</td>
<td class="tdleft">International Critical Commentary</td>
</tr>
<tr>
<td class="tdleft"><i>Int</i></td>
<td class="tdleft"><i>Interpretation</i></td>
</tr>
<tr>
<td class="tdleft"><i>JBL</i></td>
<td class="tdleft"><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td class="tdleft"><i>JETS</i></td>
<td class="tdleft"><i>Journal of the Evangelical Theological Society</i></td>
</tr>
<tr>
<td class="tdleft"><i>JR</i></td>
<td class="tdleft"><i>Journal of Religion</i></td>
</tr>
<tr>
<td class="tdleft"><i>JSNT</i></td>
<td class="tdleft"><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td class="tdleft">JSNTSup</td>
<td class="tdleft">Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td class="tdleft">JSOTSup</td>
<td class="tdleft">Journal for the Study of the Old Testament Supplement Series</td>
</tr>
<tr>
<td class="tdleft"><i>JTS</i></td>
<td class="tdleft"><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td class="tdleft">LNTS</td>
<td class="tdleft">The Library of New Testament Studies</td>
</tr>
<tr>
<td class="tdleft">LXX</td>
<td class="tdleft">Septuagint</td>
</tr>
<tr>
<td class="tdleft"><i>MDAI</i></td>
<td class="tdleft"><i>Mitteilungen des Deutschen archäologischen Instituts</i></td>
</tr>
<tr>
<td class="tdleft">MT</td>
<td class="tdleft">Masoretic Text</td>
</tr>
<tr>
<td class="tdleft"><i>NIB</i></td>
<td class="tdleft"><i>The New Interpreter’s Bible</i></td>
</tr>
<tr>
<td class="tdleft">NICNT</td>
<td class="tdleft">New International Commentary on the New Testament</td>
</tr>
<tr>
<td class="tdleft">NIGTC</td>
<td class="tdleft">New International Greek Testament Commentary</td>
</tr>
<tr>
<td class="tdleft">NovTSup</td>
<td class="tdleft">Supplements to Novum Testamentum</td>
</tr>
<tr>
<td class="tdleft"><a id="page_xiv"><i>NTS</i></a></td>
<td class="tdleft"><i>New Testament Studies</i></td>
</tr>
<tr>
<td class="tdleft"><i>PSTJ</i></td>
<td class="tdleft"><i>Perkins School of Theology Journal</i></td>
</tr>
<tr>
<td class="tdleft"><i>RQ</i></td>
<td class="tdleft"><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td class="tdleft">SANT</td>
<td class="tdleft">Studien zum Alten und Neuen Testaments</td>
</tr>
<tr>
<td class="tdleft">SBLSS</td>
<td class="tdleft">Society of Biblical Literature Symposium Series</td>
</tr>
<tr>
<td class="tdleft">SBT</td>
<td class="tdleft">Studies in Biblical Theology</td>
</tr>
<tr>
<td class="tdleft">StPatr</td>
<td class="tdleft">Studia Patristica</td>
</tr>
<tr>
<td class="tdleft"><i>TS</i></td>
<td class="tdleft"><i>Theological Studies</i></td>
</tr>
<tr>
<td class="tdleft">TU</td>
<td class="tdleft">Texte und Untersuchungen</td>
</tr>
<tr>
<td class="tdleft">WBC</td>
<td class="tdleft">Word Biblical Commentary</td>
</tr>
<tr>
<td class="tdleft"><i>WTJ</i></td>
<td class="tdleft"><i>Westminster Theological Journal</i></td>
</tr>
<tr>
<td class="tdleft">WUNT</td>
<td class="tdleft">Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td class="tdleft"><i>ZNW</i></td>
<td class="tdleft"><i>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?ce6da96e